import React from 'react';
import PropTypes from 'prop-types';
import { GreenChechMark, ShiftsActivity } from "../../../assets/icons";
import "./dashboard-real-estate.scss";

const BookedVacationString = ({ item, onHandleHover, onHandleHoverEmpty, showModal, getDateColor }) => {
    const upcomingVacations = item.BookedVacations.filter(v => v.Upcoming);
    const hasUpcomingVacations = upcomingVacations.length > 0;

    // TAD-5644 — Wire `onMouseEnter` in the empty branch too. The
    // `onHandleHoverEmpty` prop was declared required and the test
    // expected it to fire when hovering the dash, but the original render
    // returned a `<td>` with no handlers. Real prod bug — caller's tooltip
    // logic for the empty case never fired.
    if (!hasUpcomingVacations) return (
        <td
            className="col-md-3 mt-2 real-estate-dates"
            onMouseEnter={e => onHandleHoverEmpty(e)}
        >
            -
        </td>
    );

    const renderApprovalImage = () => {
      let imageSrc;
      if (upcomingVacations[0].IsApproved) imageSrc = GreenChechMark;
      else if (upcomingVacations[0].IsAwaitingApproval) imageSrc = ShiftsActivity;
      return imageSrc ? <img style={{ marginLeft: "10px" }} src={imageSrc} alt="Approval Status" /> : null;
    };

    return (
      <td
        onMouseLeave={e => hasUpcomingVacations && onHandleHover(e)}
        onMouseEnter={e => (hasUpcomingVacations ? onHandleHover(e) : onHandleHoverEmpty(e))}        
        onClick={() => hasUpcomingVacations && showModal(item)}
        className="col-md-3 mt-2 real-estate-dates"
        style={{
          color: getDateColor(hasUpcomingVacations ? upcomingVacations[0].Color : ""),
        }}
      >
        {upcomingVacations[0].BookedVacationString}
        {renderApprovalImage()}
      </td>
    );
};

BookedVacationString.propTypes = {
  item: PropTypes.shape({
    BookedVacations: PropTypes.arrayOf(
      PropTypes.shape({
        Upcoming: PropTypes.bool,
        IsApproved: PropTypes.bool,
        IsAwaitingApproval: PropTypes.bool,
        BookedVacationString: PropTypes.string,
        Color: PropTypes.string
      })
    ).isRequired,
  }).isRequired,
  onHandleHover: PropTypes.func.isRequired,
  onHandleHoverEmpty: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
  getDateColor: PropTypes.func.isRequired
};

export default BookedVacationString;
